var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { ChevronDownIconGlyph, ChevronUpIconGlyph } from '@shapeable/icons';
import { Icon } from './icon';
import { DottedLine } from './dotted-line';
var cls = classNames('select-indicator');
export var SelectIndicatorDefaultProps = {
  direction: 'down'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-flex;\n    height: 52px;\n    padding: 4px 8px;\n    justify-content: center;\n    align-items: center;\n    gap: 16px;\n  "], ["\n    display: inline-flex;\n    height: 52px;\n    padding: 4px 8px;\n    justify-content: center;\n    align-items: center;\n    gap: 16px;\n  "])))
});
var IconStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Icon: styled(Icon).attrs(cls.attr('icon'))(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), IconStyles)
};
export var SelectIndicator = function (props) {
  var className = props.className,
    direction = props.direction,
    color = props.color;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(DottedLine, {
    width: 2,
    gap: 5,
    colors: {
      border: color
    }
  }), React.createElement(My.Icon, {
    size: 16,
    color: color
  }, direction === 'down' ? React.createElement(ChevronDownIconGlyph, null) : React.createElement(ChevronUpIconGlyph, null)));
};
SelectIndicator.cls = cls;
SelectIndicator.defaultProps = SelectIndicatorDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;